/* eslint no-dupe-keys: 0, no-mixed-operators: 0 */

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import { observer } from 'mobx-react';
import { ListView } from 'antd-mobile';
import store from '../../stores/category-store';
import Server from '../../common/server';


class ListViewComponent extends Component {
  constructor(props) {
    super(props);

    const dataSource = new ListView.DataSource({
      rowHasChanged: (row1, row2) => row1 !== row2,
    });
    this.pageNo = 0;
    this.rData = [];

    this.state = {
      // 更新分类
      topCat: store.topCat,
      secondCat: store.secondCat,
      thirdCat: store.thirdCat,
      // 把数据保存到 STATE 才会刷新
      dataSource,
      isLoading: true,
      height: document.documentElement.clientHeight * 3 / 4,
      hasMore: true,
    };
  }
  // 获取数据
  genData = () => {
    const me = this;
    let data = {
      topCat: store.topCat,
      secondCat: store.secondCat,
      thirdCat: store.thirdCat,
      page: me.pageNo,
      size: 20,
    }

    me.pageNo++;

    const promise = new Promise(function (resolve, reject) {
      Server.GetColumnsList(data, function (res) {
        // console.log('genData 请求成功', '当前页:', me.pageNo );
        // console.log(res);
        if (res.code = 200) {
          if (res.data.list.length > 0) {
            let feedback = {
              msg: 'success',
              data: res.data.list,
              code: 1
            }
            resolve(feedback);
          } else {
            let noData = {
              msg: '么有更多数据了',
              data: [],
              code: 2
            }
            resolve(noData)
          }
        } else {
          // 跳转加载错误
          let error = {
            msg: '信息获取失败！',
            data: [],
            code: 3
          }
          reject(new Error(error))
          console.error(error.msg);
        }
      })

    })
    return promise;
  }
  // 组件提供，页面滑动到最低端触发
  onEndReached = (event) => {
    const me = this;
    // load new data
    // hasMore: from backend data, indicates whether it is the last page, here is false
    if (this.state.isLoading && !this.state.hasMore) {
      return;
    }
    console.log('reach end', event);
    this.setState({ isLoading: true });
    me.genData().then(function (json) {
      // console.log('执行 gendata');
      // console.log(json);
      if (json.code === 1) {
        me.rData = [...me.rData, ...json.data];
        // console.log('ggggggg:');
        // console.log(me.rData)
        me.setState({
          dataSource: me.state.dataSource.cloneWithRows(me.rData),
          isLoading: false,
        });
      } else if (json.code === 2) {
        // console.log('么有更多数据了');
        me.setState({
          isLoading: false,
        });
      }
    }, function (error) {
      console.error('请求数据失败！');
      me.setState({
        isLoading: false,
      });
    })


    this.setState({
      dataSource: this.state.dataSource.cloneWithRows(this.rData),
      isLoading: false,
    })
  }

  // 每次分类参数更新触发
  componentWillReceiveProps(nextProps) {
    const me = this;
    this.rData = []; // 结合cloneWithRows 清空dataSource
    this.setState({
      topCat: store.topCat,
      secondCat: store.secondCat,
      thirdCat: store.thirdCat,
      dataSource: me.state.dataSource.cloneWithRows(me.rData),
      isLoading: true,
      height: document.documentElement.clientHeight * 3 / 4,
      hasMore: true,
    })
    console.log('componentWillReceiveProps');
    const hei = document.documentElement.clientHeight - ReactDOM.findDOMNode(this.lv).parentNode.offsetTop;
    me.pageNo = 0;
    me.genData().then(function (json) {
      // console.log('执行 gendata');
      // console.log(json);
      if (json.code === 1) {
        me.rData = json.data;
        // console.log('ggggggg:');
        // console.log(me.rData)
        me.setState({
          dataSource: me.state.dataSource.cloneWithRows(me.rData),
          height: hei,
          isLoading: false,
        });
        me.lv.scrollTo(0, 0);
      } else if (json.code === 2) {
        // console.log('么有更多数据了');
        me.setState({
          isLoading: false,
          hasMore: false,
        })
      }
    }, function (error) {
      console.error('请求数据失败！');
    })
  }

  componentDidMount() {
    const me = this;
    me.pageNo = 0;
    me.genData().then(function (json) {
      // console.log('执行 gendata');
      // console.log(json);
      if (json.code === 1) {
        me.rData = json.data;
        // console.log('ggggggg:');
        // console.log(me.rData)
        me.setState({
          dataSource: me.state.dataSource.cloneWithRows(me.rData),
          height: document.documentElement.clientHeight - ReactDOM.findDOMNode(me.lv).parentNode.offsetTop,
          isLoading: false,
        });
        me.lv.scrollTo(0, 0);
      } else if (json.code === 2) {
        // console.log('么有更多数据了');
        me.setState({
          hasMore: false,
          isLoading: false,
        })
      }
    }, function (error) {
      console.error('请求数据失败！');
    })
  }

  // 点击专栏发log
  skipColumn = (e, name) => {
    window._rlog.push([ "_trackCustom" , "EVENT", [['action', 'click_column'],['column_name', name],['datafrom','categorypage']] ]);
  }

  render() {

    const row = (rowData, sectionID, rowID) => {
      // rowData 关键字段
      // console.log(rowData);
      
      return (
        <div key={rowID} className="rowList">

          <a href={'yddict://youdao.com/listening?page=column&id=' + rowData.name} style={{ display: '-webkit-box', display: 'flex', padding: '15px 0' }} onClick={ (e) => this.skipColumn(e, rowData.name)}>

            <img className="column-image" src={rowData.image.replace(/https/g, "http")} alt={rowData.title} />

            <div style={{ lineHeight: 1, width: '4.66rem', position: 'relative' }}>
              <div className="column-title">
                {
                  rowData.vip &&
                  <span className="vip-icon"></span>
                }
                {rowData.title}
              </div>
              <div className="column-intro">{rowData.intro}</div>
              <div className="column-span">
                <span>{rowData.visitNum ? rowData.visitNum : '0'}人在听</span> |&nbsp;
                <span>{rowData.totalElements ? rowData.totalElements : '0'}篇</span>
              </div>
            </div>
          </a>
        </div>
      )
    };

    return (

      <div>
        {/* {store.topCat} - {store.secondCat} - {store.thirdCat} - {this.pageNo} */}

        <ListView
          className="list-view"
          ref={el => this.lv = el}
          dataSource={this.state.dataSource}
          renderFooter={() => (<div className='list-view-footer'>
            {this.state.isLoading ? 'Loading...' : '更多内容持续更新中~'}
          </div>)}
          // List内容
          renderRow={row}
          style={{
            height: this.state.height,
            overflow: 'auto',
          }}
          pageSize={4}
          onScroll={() => { console.log('scroll'); }}
          scrollRenderAheadDistance={500}
          onEndReached={this.onEndReached}
        />
      </div>
    );
  }
}

export default observer(ListViewComponent);